module.exports = __webpack_public_path__ + "static/media/sz.0b30b061.svg";